.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1, 8px);
  padding: var(--tuna-spacing-2, 16px) var(--tuna-spacing-2, 16px) var(--tuna-spacing-1, 8px);
  animation: fadeIn 100ms ease-out both;
}

@media (prefers-reduced-motion: reduce) {
  .container {
    animation: none;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1, 8px);
}

.chip {
  appearance: none;
  background: transparent;
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-radius-xl);
  padding: 4px 12px;
  font: inherit;
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary, var(--tuna-palette-text-secondary));
  cursor: pointer;
  text-align: left;
  line-height: 1.4;
  transition:
    background-color 100ms ease-out,
    border-color 100ms ease-out;
}

.chip:hover {
  background: var(--tuna-palette-action-hover, rgba(0, 0, 0, 0.04));
}

.chip:focus-visible {
  outline: 2px solid var(--tuna-focus-ring, var(--tuna-palette-primary-main));
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .chip {
    transition: none;
  }
}
